import React from 'react'
import { motion } from 'framer-motion';
import Carousel from 'react-multi-carousel'
import 'react-multi-carousel/lib/styles.css'
import { FiChevronRight, FiChevronLeft } from 'react-icons/fi'
import { Link } from 'react-router-dom'
import { HiStar } from "react-icons/hi2";
import { FaWhatsapp } from 'react-icons/fa';
const Products = ({ title, products, }) => {

    const responsive = {
        superLargeDesktop: {
            breakpoint: { max: 4000, min: 3000 },
            items: 1
        },
        desktop: {
            breakpoint: { max: 3000, min: 1024 },
            items: 1
        },
        tablet: {
            breakpoint: { max: 1024, min: 464 },
            items: 1
        },
        mobile: {
            breakpoint: { max: 464, min: 0 },
            items: 1
        }
    }
    const ButtonGroup = ({ next, previous }) => {
        return (
            <div className='flex justify-between items-center'>
                <button onClick={() => previous()} className='w-[30px] rounded-full h-[30px] flex justify-center items-center text-primaryBackground bg-secondary'>
                    <span><FiChevronLeft /></span>
                </button>
                <div className='text-xl font-semibold text-primary'>{title}</div>
                <div className='flex justify-center items-center gap-3'>

                    <button onClick={() => next()} className='w-[30px] rounded-full h-[30px] flex justify-center items-center text-primaryBackground bg-secondary'>
                        <span><FiChevronRight /></span>
                    </button>
                </div>
            </div>
        )
    }
    return (
        <div className='flex gap-7 w-[97%] md:w-[100%] flex-col-reverse'>
            <Carousel
                autoPlay={false}
                infinite={false}
                arrows={false}
                responsive={responsive}
                transitionDuration={500}
                renderButtonGroupOutside={true}
                customButtonGroup={<ButtonGroup />}
                className='rounded-[10px]'
            >
                {
                    products.map((p, i) => {
                        return (
                            <div key={i} className='flex flex-col w-[96%] justify-start gap-4 '>
                                {
                                    p.map((pl, j) => <motion.div className="w-full h-full rounded-3xl hover:bg-card hover:drop-shadow-sm" whileHover={{ x: 2 }} whileTap={{ scale: 0.97 }}>
                                        <Link
                                            key={j}
                                            className='flex gap-1 justify-start items-start'
                                            to={`/product/details/${pl.slug}`}
                                        >
                                            <img className='w-[110px] rounded-2xl h-[110px]' src={pl.images[0]} alt="images" />
                                            <div className='p-3 flex justify-start items-start gap-1.5 flex-col text-primary w-full relative'>
                                                <h2 className='text-primary '>{pl.name}</h2>
                                                <span className='text-sm flex items-center'><HiStar className='mr-1 text-[#EDBB0E]' /> {pl.rating}/5 </span>
                                                <div className='flex justify-between items-center w-full'>
                                                    <span className='text-lg font-medium'>Rs.{pl.discount ? pl.price - Math.floor((pl.price * pl.discount) / 100) : pl.price}</span>
                                                    {/* {pl.sellerId?.whatsappNumber && (
                                                        <a 
                                                            href={`https://wa.me/${pl.sellerId.whatsappNumber}?text=${encodeURIComponent(
                                                                `Hello, I want to buy this product:\n\n*Name:* ${pl.name}\n*SKU:* ${pl.sku || 'N/A'}\n*Price:* Rs.${pl.discount > 0 ? pl.price - Math.floor((pl.price * pl.discount) / 100) : pl.price}\n*Link:* ${window.location.origin}/product/details/${pl.slug}`
                                                            )}`}
                                                            target='_blank' 
                                                            rel='noreferrer'
                                                            onClick={(e) => e.stopPropagation()}
                                                            className='p-2 bg-green-500 text-white rounded-full hover:bg-green-600 transition-colors'
                                                        >
                                                            <FaWhatsapp size={16} />
                                                        </a>
                                                    )} */}
                                                </div>
                                            </div>
                                        </Link>
                                    </motion.div>)
                                }
                            </div>
                        )
                    })
                }
            </Carousel>
        </div>
    )
}

export default Products